import React, {useEffect} from 'react'
import {Link} from "react-router-dom"

const Privacy = (props) => {

  useEffect(() => {
    window.scrollTo(0,0)
  },[])

  return ( <>
  <div style={{ position: 'relative' }}>

    <audio controls src={`${process.env.PUBLIC_URL}/songs/Estoy Embarazada - OurStorySong.mp3`}></audio>
    <br/>
    <a href={`${process.env.PUBLIC_URL}/songs/Estoy Embarazada - OurStorySong.mp3`} download>Download</a>

    <h2>Estoy Embarazada</h2>

    <p>
        [Verse 1]<br/>
        Off to Cholula, south of Mexico City<br/>
        College of the Americas, life was feeling pretty<br/>
        Two American girls on a long, winding ride<br/>
        Not the express bus, but chickens inside<br/>
        <br/>
        [Pre-Chorus]<br/>
        Talking and laughing, the whole bus joined in<br/>
        Lost in the music, not knowing where to begin<br/>
        Spanish on my tongue, English in my brain<br/>
        Back and forth translating, dancing in the rain<br/>
        <br/>
        [Chorus]<br/>
        Estoy embarazada! — no, that’s not what I meant<br/>
        All the family staring, their jaws just bent<br/>
        Estoy embarazada! — laughter in my soul<br/>
        A little mistake that still makes the story whole<br/>
        <br/>
        [Verse 2]<br/>
        Quinceañera dresses, church bells ringing loud<br/>
        Families together, fiesta in the crowd<br/>
        Pink painted walls, cushions wrapped in white<br/>
        Learning a language by the firelight<br/>
        <br/>
        [Pre-Chorus]<br/>
        Every word a window, every joke a song<br/>
        Inside the rhythm where I belong<br/>
        Even when I stumbled, I found my way<br/>
        Mexico’s heartbeat taught me how to stay<br/>
        <br/>
        [Chorus]<br/>
        Estoy embarazada! — no, that’s not what I meant<br/>
        All the family staring, their jaws just bent<br/>
        Estoy embarazada! — laughter in my soul<br/>
        A little mistake that still makes the story whole<br/>
        <br/>
        [Bridge]<br/>
        Buses and chickens, pen pals and friends<br/>
        Stories in Spanish that never quite end<br/>
        Embarrassed or pregnant, who really can say?<br/>
        But I’d live it again in the very same way<br/>
        <br/>
        [Chorus]<br/>
        Estoy embarazada! — no, that’s not what I meant<br/>
        All the family staring, their jaws just bent<br/>
        Estoy embarazada! — laughter in my soul<br/>
        A little mistake that still makes the story whole<br/>
        <br/>
        [Outro]<br/>
        Oh, the salsa’s playing, the night feels right<br/>
        Mexico, mi corazón, you lit up my life<br/>
        Estoy embarazada! — forever the refrain<br/>
        A memory of Mexico that always will remain<br/>
    </p>

    </div>
  </> )
}

export default Privacy
